import {
  FinancialProductEnum,
  TaxType,
} from '@app/pages/quote/open-quote/model/open-quote.model';

export const taxFreeOptionsNew = [
  {
    value: true,
    display: 'SI',
  },
  {
    value: false,
    display: 'NO',
  }
]

export const taxTypeWarrantyOptions = [
  {
    value: TaxType.numberOfRents,
    display: 'Mensualidades',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.invoiceWithTax,
    display: '% Valor con IVA',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.invoiceWithoutTax,
    display: '% Valor sin IVA',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.fixedAmount,
    display: 'Monto fijo',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: null,
    display: 'No aplica',
    isValidToSelect: (financialProduct: any) =>
      [
        FinancialProductEnum.directCredit,
        FinancialProductEnum.financialLeasing,
        FinancialProductEnum.directCreditGlobe,
        FinancialProductEnum.capLoan,
        FinancialProductEnum.realEstate,
      ].includes(financialProduct),
  },
];

export const additionalCollateralTypeOptions = [
  {
    value: 'UNIT_VALUE',
    display: '% Valor unidad',
  },
  {
    value: 'TOTAL_VALUE',
    display: '% Valor total',
  },
  {
    value: null,
    display: 'No aplica',
  },
];

export const residualValueTypeOptions = [
  {
    value: TaxType.invoiceWithTax,
    display: 'valueIncludingVAT',
    percentage: true,
  },
  {
    value: TaxType.invoiceWithoutTax,
    display: 'valueExcludeVAT',
    percentage: true,
  },
  {
    value: TaxType.amountToFinance,
    display: 'Amount to Finance',
    percentage: true,
  },
  {
    value: TaxType.fixedAmount,
    display: 'Fixed Amount',
    percentage: false,
  },
  {
    value: null,
    display: '',
    hidden: true,
    percentage: false,
  },
];

export const classificationOptions = [
  {
    value: 'USED',
    display: 'Used',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: 'NEW',
    display: 'New',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: null,
    display: 'Not Applicable',
    isValidToSelect: (insuranceChecked: any) => !insuranceChecked,
  }
];

export const subsidyTypeOptions = [
  {
    value: TaxType.invoiceWithTax,
    display: 'valueIncludingVAT',
    percentage: true,
  },
  {
    value: TaxType.invoiceWithoutTax,
    display: 'valueExcludeVAT',
    percentage: true,
  },
  {
    value: TaxType.amountToFinance,
    display: 'Amount to Finance',
    percentage: true,
  },
  {
    value: TaxType.fixedAmount,
    display: 'Fixed Amount',
    percentage: false,
  },
  {
    value: null,
    display: 'Not Applicable',
    percentage: false,
  },
];

export const taxTypeDownPaymentOptions = [
  {
    value: TaxType.invoiceWithTax,
    display: '% Valor con IVA',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.invoiceWithoutTax,
    display: '% Valor sin IVA',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.fixedAmount,
    display: 'Monto fijo',
    isValidToSelect: (financialProduct: any) => true,
  },
];

export const taxTypeBalloonOptions = [
  {
    value: TaxType.invoiceWithTax,
    display: '% Valor con IVA',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.invoiceWithoutTax,
    display: '% Valor sin IVA',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.amountToFinance,
    display: '% Monto a financiar',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: TaxType.fixedAmount,
    display: 'Monto fijo',
    isValidToSelect: (financialProduct: any) => true,
  },
  {
    value: null,
    display: 'No Aplica',
    isValidToSelect: (financialProduct: any) => true
  },
];

export const controlWatchingArray = [
  'financialProductType', 'productType', 'classification', 'modelId', 'year',
  'includesInsurance', 'unitPriceWithoutTax', 'unitPriceWithTax',
  'customerRate', 'paymentType',
  'downPaymentTaxType',
  'warrantyDeposit', 'warrantyDepositPercentage', 'warrantyDepositMonth', 'warrantyDepositTotal',
  'tax', 'term', 'brandId', 'subBrandId',
  'lifeInsuranceFactor',
  'purchaseOptionType', 'purchasePercentage', 'purchaseTotal'
];

export const controlsInsuranceUpdateArray = ["term", "financialProductType", "currencyType", "customerRate", "paymentType", "quantity", "taxFree", "paymentFormationType", "openingFeeType", "openingFeePercentage", "downPaymentTaxType", "downPaymentTax", "downPayment", "lifeInsuranceFactor", "openingFee", "balloonType", "balloon", "balloonPercentage", "confirmationExpensesAmount", "grace", "residualValueType", "residualValuePercentage", "residualValueTotal"];
